/**
 * Resolves the structure path based on the field path and configuration
 *
 * Assumes structurePath doesn't contain any special cases in the path (supports `.split('.')`)
 *
 * @param fieldPathArray The path of the field that changed as an array of path segments (e.g., ['arguments', 'messaging', 'title'])
 * @param structurePath The configured structure path ('parent' or explicit path)
 */
export const resolveStructurePath = (fieldPathArray: PropertyKey[], structurePath: string): PropertyKey[] =>
  structurePath === 'parent' ? fieldPathArray.slice(0, -1) : structurePath.split('.');
